// extracted by mini-css-extract-plugin
export default {"parent":"formPassword_parent__6vUKt","parentErrorInform":"formPassword_parentErrorInform__yFdM8","parentInputPassword":"formPassword_parentInputPassword__vRHUs"};